module.exports = __webpack_public_path__ + "img/illu-koala.f6e46574.svg";